import { AiAnalyticsEntityType, AiLogsTab } from '@/types/ai-logs';

export const AI_LOGS_TABS: {
  id: AiLogsTab;
  label: string;
  totalsLabel: string;
  documentKind: 'invoice' | 'audit' | 'ticket';
  entityType?: AiAnalyticsEntityType;
  entityLabel: string;
}[] = [
  {
    id: 'invoice',
    label: 'Invoices',
    totalsLabel: 'Total Invoices Processed',
    documentKind: 'invoice',
    entityLabel: 'invoices'
  },
  {
    id: 'event',
    label: 'Events',
    totalsLabel: 'Total Events Processed',
    documentKind: 'audit',
    entityType: 'event',
    entityLabel: 'events'
  },
  {
    id: 'event_m_audit',
    label: 'Audits',
    totalsLabel: 'Total Audits Processed',
    documentKind: 'audit',
    entityType: 'event_m_audit',
    entityLabel: 'audits'
  },
  {
    id: 'finding',
    label: 'Findings',
    totalsLabel: 'Total Findings Processed',
    documentKind: 'audit',
    entityType: 'finding',
    entityLabel: 'findings'
  },
  {
    id: 'ticket',
    label: 'Tickets',
    totalsLabel: 'Total Tickets Processed',
    documentKind: 'ticket',
    entityType: 'ticket',
    entityLabel: 'tickets'
  }
];

export const DEFAULT_AI_LOGS_TAB: AiLogsTab = 'invoice';

export const getAiLogsTabConfig = (tab: AiLogsTab) =>
  AI_LOGS_TABS.find(item => item.id === tab) ?? AI_LOGS_TABS[0];

export const isAiLogsTab = (value: string | undefined): value is AiLogsTab =>
  AI_LOGS_TABS.some(item => item.id === value);
